<div class="app-page flex-column flex-column-fluid" id="kt_app_page">
  <div class="app-wrapper flex-column flex-row-fluid" [ngClass]="{ 'w-100 m-0': isAuthPage }" id="kt_app_wrapper">
    <!-- <app-sidebar *ngIf="!isAuthPage"></app-sidebar> -->
    <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
      <div class="d-flex flex-column flex-column-fluid">
        <div id="kt_app_content" class="app-content flex-column-fluid">
          <div id="kt_app_content_container" class="app-container container-fluid">
            <ng-container *ngIf="isAuthPage">
              <app-login></app-login>
            </ng-container>

            <ng-container *ngIf="!isAuthPage">
                <app-main></app-main>
            </ng-container>

          </div>
        </div>
      </div>
    </div>
    <!-- <app-footer *ngIf="!isAuthPage"></app-footer> -->
  </div>
</div>

<app-activity-drawer></app-activity-drawer>

<app-chat-drawer></app-chat-drawer>

<app-shop-drawer></app-shop-drawer>

<app-upgrade-plan-modal></app-upgrade-plan-modal>

<app-create-app-modal></app-create-app-modal>

<app-create-app-modal></app-create-app-modal>

<app-new-target-modal></app-new-target-modal>

<app-view-users-modal></app-view-users-modal>

<app-users-search-modal></app-users-search-modal>

<app-invite-friends-modal></app-invite-friends-modal>
